import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, useTheme } from '@mui/material';
import { FiAlertCircle } from 'react-icons/fi';

const AlertBox = ({ children, icon, useIcon, sx = {}, severity = 'warning' }) => {
  const theme = useTheme();
  const bg = {
    info: theme.palette.info.light,
    warning: theme.palette.warning.light,
    error: theme.palette.error.light,
    success: theme.palette.success.light,
  };
  const color = {
    info: theme.palette.info.contrastText,
    warning: theme.palette.warning.contrastText,
    error: theme.palette.error.contrastText,
    success: theme.palette.success.contrastText,
  };
  return (
    <Box
      sx={{
        width: '100%',
        p: 2,
        borderRadius: 1,
        bgcolor: bg[severity] || theme.palette.grey[200],
        color: color[severity] || theme.palette.text.primary,
        textShadow: '0.5px 0.5px 0.5px rgba(0,0,0,0.2)',
        ...sx,
      }}
    >
      <Typography variant='body2'>
        {useIcon ? <>{useIcon}&nbsp;</> : null}
        {icon && (
          <span style={{ marginRight: '0.5em' }}>
            {severity === 'warning' && <FiAlertCircle />}
          </span>
        )}
        {children}
      </Typography>
    </Box>
  );
};
AlertBox.propTypes = {
  severity: PropTypes.oneOf(['info', 'warning', 'error', 'success']),
  children: PropTypes.node.isRequired,
  icon: PropTypes.bool,
  sx: PropTypes.object,
  useIcon: PropTypes.node,
};
export default AlertBox;
